module.exports = __webpack_public_path__ + "static/media/resume.b94314e4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/view/global/assets/resume.pdf
// module id = 31
// module chunks = 0